/*
 * Sticky Add-to-Cart-Leiste (Mobil) - gehoert zu snippets/buy-buttons.liquid
 *
 * Die Leiste hat bewusst KEIN eigenes Formular: ein Klick loest den echten
 * Warenkorb-Button der Produktseite aus. Dadurch bleiben Variante, Menge und
 * Preis immer synchron, und Apps, die sich an das Produktformular haengen
 * (Globo Product Options, Klaviyo, Pixel-Tracking), funktionieren unveraendert.
 *
 * Zwei Robustheits-Entscheidungen:
 * 1. Scroll wird sowohl an window als auch am document in der Capture-Phase
 *    abgehoert. Scroll-Events blubbern nicht - je nachdem, welches Element
 *    tatsaechlich scrollt, erreicht das Event window sonst nie.
 * 2. Die Elemente werden bei jedem Frame frisch aus dem DOM geholt. Wenn die
 *    Produkt-Section nach einem Variantenwechsel neu gerendert wird, greift die
 *    Logik automatisch auf die neuen Knoten zu - es gibt nichts, was veralten kann.
 */
(function () {
  if (window.__stickyAtcBound) return;
  window.__stickyAtcBound = true;

  var ticking = false;

  function update() {
    ticking = false;
    var bars = document.querySelectorAll('[data-sticky-atc]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var watch = document.querySelector(bar.getAttribute('data-watch'));
      var show = false;
      if (watch) {
        var rect = watch.getBoundingClientRect();
        // Anzeigen, sobald der echte Button oben aus dem Sichtfeld gescrollt ist.
        // rect.height > 0 schliesst ausgeblendete Buttons aus (z. B. ausverkauft
        // ohne Benachrichtigungsformular) - dann gibt es nichts zu klicken.
        show = rect.height > 0 && rect.bottom < 0;
      }
      if (bar.classList.contains('is-visible') !== show) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(update);
    } else {
      setTimeout(update, 16);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', update);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  // Delegierter Klick - ueberlebt jedes Neu-Rendern der Produkt-Section
  document.addEventListener('click', function (event) {
    var origin = event.target;
    var button = origin && origin.closest ? origin.closest('.sticky-atc__button') : null;
    if (!button) return;
    var bar = button.closest('[data-sticky-atc]');
    if (!bar) return;
    var target = document.querySelector(bar.getAttribute('data-target'));
    if (target) target.click();
  });
})();